module.exports = __webpack_public_path__ + "static/media/filteration.ea87e048.png";